import React, { useState, useEffect } from 'react';
import Base from '../../Base';
import Api from '../../Services/ApiCall';
import { Link } from "react-router-dom";
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import 'ag-grid-enterprise/styles/ag-theme-alpine.css';
import 'ag-grid-enterprise';
import { Modal, Button, Alert } from 'react-bootstrap';
import Swal from 'sweetalert2';

export default function PayoutTable() {
    const [rowData, setRowData] = useState([]);
    const [quickFilterText, setQuickFilterText] = useState("");
    const [showPopup, setShowPopup] = useState(false);
    const [selectedRowData, setSelectedRowData] = useState(null);
    const [remark, setRemark] = useState("");
    useEffect(() => {
        fetchDataAndSetState();
    }, []);

    const fetchDataAndSetState = async () => {
        try {
            var Param = { mstpayoutid: 0, flag: sessionStorage.getItem('AccessType') };
            var url = "/CommanAPI/BindPayout";
            let _response1 = await Api.BindGrid(Param, url);
            setRowData(_response1);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const columnDefs = [
        { headerName: 'Agent Code', field: 'AgentCode', filter: true, enableFilter: true },
        { headerName: 'Amount', field: 'Amount', filter: true, enableFilter: true },
        { headerName: 'Status', field: 'Status', filter: true, enableFilter: true },
        { headerName: 'Created Date', field: 'CreatedDate', filter: true, enableFilter: true },
        { headerName: 'Remarks', field: 'Remarks', filter: true, enableFilter: true },
        { headerName: 'Updated By', field: 'UpdatedBy1', filter: true, enableFilter: true },
        { headerName: 'Updated Date', field: 'UpdatedDate', filter: true, enableFilter: true },
    ];

    const onQuickFilterChange = (event) => {
        setQuickFilterText(event.target.value);
    };

    const isAddButtonEnabled = () => {
        const currentDay = new Date().getDate();
        return (currentDay >= 1 && currentDay <= 3) || (currentDay >= 15 && currentDay <= 17);
    };
    const onCellClicked = (params) => {
        if (sessionStorage.getItem('AccessType') == 'User') {
            openPopup({ id: params.data.Mstpayoutid, code: params.data.AgentCode, amount: params.data.Amount });
        }
    };
    const openPopup = (rowData) => {
        setSelectedRowData(rowData);
        Get(rowData.id)
        setShowPopup(true);
    };
    const Get = async (id) => {
        try {
            var Param = { mstpayoutid: id, flag: sessionStorage.getItem('AccessType') };
            var url = "/CommanAPI/BindPayout";
            let _response1 = await Api.BindGrid(Param, url);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const closePopup = () => {
        setSelectedRowData(null);
        setShowPopup(false);
    };

    const Approve = async (id, amount, code) => {
        try {
            var Param = { mstpayoutid: id, flag: "U", remarks:remark,status: "Approved", amount: amount, agentCode: code };
            var url = "/CommanAPI/CreatePayout";
            let _response = await Api.IUD(Param, url);
            const message = JSON.parse(_response);
            if (message.Message == "Your wallet amount is too low.") {
                Swal.fire({
                    title: "Failed",
                    text: message.Message,
                    icon: "failed",
                    confirmButtonText: "OK",
                });
            } else {
                showAlert(message.Message)
            }
            fetchDataAndSetState(0);
            closePopup();
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const Reject = async (id, amount, code) => {
        try {
            var Param = { mstpayoutid: id, flag: "U", remarks:remark,status: "Rejected", amount: amount, agentCode: code };
            var url = "/CommanAPI/CreatePayout";
            let _response = await Api.IUD(Param, url);
            const message = JSON.parse(_response);
            if (message.Message == "Your wallet amount is too low.") {
                Swal.fire({
                    title: "Failed",
                    text: message.Message,
                    icon: "failed",
                    confirmButtonText: "OK",
                });
            } else {
                showAlert(message.Message)
            }
            fetchDataAndSetState(0);
            closePopup();
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const showAlert = (_response) => {
        Swal.fire({
            title: "Success",
            text: _response,
            icon: "success",
            confirmButtonText: "OK",
        });
    };

    return (
        <div>
            <Base />
            <div id="main" className="main">
                <div className="pagetitle">
                    <nav>
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">
                                <Link to="/dash">Home</Link>
                            </li>
                            <li className="breadcrumb-item">Payout</li>
                            <li className="breadcrumb-item active">Payout Table</li>
                        </ol>
                    </nav>
                </div>
                <input
                    type="text"
                    placeholder="Search..."
                    onChange={onQuickFilterChange}
                    style={{ marginBottom: '10px' }}
                />
                {sessionStorage.getItem('AccessType') == 'Agent' ?
                    <>
                        <button type="button" className="btn btn-primary Add"
                            style={{ background: '#0782d0ed' }}
                            disabled={!isAddButtonEnabled()}>
                            <Link to={'/PayoutForm'}
                                state={{ ID: 0, Flag: 'I' }}
                                style={{ color: "white", textDecoration: 'none' }}>
                                Add
                            </Link>
                        </button>
                    </>
                    : null}
                <h6 style={{ color: 'red', marginTop: '10px' }}>
                    Note: The Add option is enabled only on the 1st to 3rd and 15th to 17th of each month.
                </h6>

                <div className="ag-theme-alpine" style={{ height: 400, width: '100%' }}>
                    <AgGridReact
                        rowData={rowData}
                        columnDefs={columnDefs}
                        pagination={true}
                        paginationPageSize={10}
                        domLayout='autoHeight'
                        floatingFilter={true}
                        enableBrowserTooltips={true}
                        onCellClicked={onCellClicked}
                        quickFilterText={quickFilterText}
                    />
                </div>

                {showPopup && selectedRowData && (
                    <Modal show={true} onHide={closePopup} dialogClassName="custom-modal">
                        <Modal.Header closeButton>
                            <Modal.Title>Payout Confirmation - {selectedRowData.code}</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <div className="row g-3">
                                <p>
                                    Are you sure you want to proceed with this payout amount of{" "}
                                    <strong>{selectedRowData.amount ?? "N/A"}</strong>?
                                </p>
                                <div className="text-center">
                                    <label>Remark</label>
                                    <textarea class="form-control mt-2" placeholder="Remark" value={remark} onChange={(e) => setRemark(e.target.value)} ></textarea>
                                    <button
                                        type="button"
                                        className="btn btn-success me-2"
                                        onClick={() => {
                                            Approve(selectedRowData.id, selectedRowData.amount, selectedRowData.code);
                                        }}
                                    >
                                        Approve
                                    </button>
                                    <button
                                        type="button"
                                        className="btn btn-danger"
                                        onClick={() => {
                                            Reject(selectedRowData.id, selectedRowData.amount, selectedRowData.code);
                                        }}
                                    >
                                        Reject
                                    </button>
                                </div>
                            </div>
                        </Modal.Body>
                    </Modal>
                )}


            </div>
        </div>
    );
}
